import React from 'react';

export default function GDPRCompliance() {
  return (
    <div className="bg-white min-h-screen flex flex-col py-10 px-2">
      <div className="max-w-3xl mx-auto bg-white rounded-xl shadow-xl border border-gray-200 p-8">

        {/* Header */}
        <div className="text-center mb-8">
          <h1 className="text-3xl md:text-4xl font-extrabold text-blue-900 mb-2 text-center">
            GDPR Compliance Policy
          </h1>
          <p className="text-lg text-gray-700">
            Million2Trillion (M2T) fully complies with the European Union's General Data Protection Regulation (GDPR) to protect your personal data and privacy.
          </p>
        </div>

        {/* GDPR Content */}
        <div className="border border-purple-200 bg-purple-50 p-6 rounded-2xl shadow mb-10 space-y-6 text-gray-700 text-base">

          <h2 className="text-2xl font-bold text-purple-600">Scope of GDPR Protection</h2>
          <p>
            This policy applies to any M2T user located within the European Economic Area (EEA), the United Kingdom (UK), or any region following GDPR-style privacy regulations.
          </p>

          <h2 className="text-2xl font-bold text-purple-600">Data Collection Transparency</h2>
          <ul className="list-disc space-y-3 pl-6">
            <li>We collect only the minimum data required for platform registration, verification, payment processing, and service delivery.</li>
            <li>All personal data collected during KYC, account creation, or financial transactions is securely stored and encrypted.</li>
            <li>No sensitive information is ever sold, traded, or commercially shared to unauthorized third parties.</li>
          </ul>

          <h2 className="text-2xl font-bold text-purple-600">Your GDPR Rights</h2>
          <ul className="list-disc space-y-3 pl-6">
            <li>✅ Right to Access Your Data</li>
            <li>✅ Right to Correct/Rectify Your Data</li>
            <li>✅ Right to Erasure ("Right to Be Forgotten")</li>
            <li>✅ Right to Restrict Processing</li>
            <li>✅ Right to Data Portability (Transfer of Data)</li>
            <li>✅ Right to Object to Automated Decision Making</li>
          </ul>

          <h2 className="text-2xl font-bold text-purple-600">Data Storage &amp; Security</h2>
          <ul className="list-disc space-y-3 pl-6">
            <li>All user data is stored on secure, encrypted cloud servers hosted inside GDPR-compliant data centers.</li>
            <li>We implement firewalls, encryption protocols, and restricted data access permissions internally.</li>
          </ul>

          <h2 className="text-2xl font-bold text-purple-600">Data Retention Policy</h2>
          <ul className="list-disc space-y-3 pl-6">
            <li>User data will be retained only as long as necessary for legal compliance, tax reporting, or contractual platform obligations.</li>
            <li>Data may be retained beyond account closure if required by anti-fraud, dispute resolution, or financial record-keeping obligations.</li>
          </ul>

          <h2 className="text-2xl font-bold text-purple-600">Reporting Data Breaches</h2>
          <p>
            In the event of any suspected data breach, M2T will notify affected users and relevant regulatory bodies within 72 hours, as required by GDPR regulations.
          </p>

          <h2 className="text-2xl font-bold text-purple-600">Contact for GDPR Requests</h2>
          <p>
            Users may submit GDPR-related requests by contacting:<br/>
            Email: <a href="mailto:gdpr@million2trillion.com" className="text-blue-700 underline">gdpr@million2trillion.com</a><br/>
            (Our official Data Protection Officer will respond within legally mandated timeframes.)
          </p>
        </div>


      </div>
    </div>
  );
}
